import React from 'react';
import { Link } from 'react-router-dom';
import { Hero } from "../../components/header/header";

import ImageClassroom from "../../assets/images/churchill-fellowship-logo.webp";

function Education() {
    const pageTitle = 'Education';
    document.title = global.AppName + ' - ' + pageTitle;
    return (
        <>
            <Hero title={"Education"} subtitle={"Promoting the value of leather"} ></Hero>

            {/* start main */}
            <div translate='no' className="main_bg">
                <div className="wrap">
                    <div className="main" id="support">
                        <section id='fashion'>
                            <h2>Fashion as a force for Nature</h2>
                            <p>
                            </p>
                        </section>
                        <div className="clear"></div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Education;